import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { UserContext } from '.';
import { getUsersPlaylists, createPlaylist, deletePlaylist, playlistAddItem } from 'services/post';
import { notifySuccess, notifyError } from '../notifications';

export const PlaylistsContext = React.createContext({});
PlaylistsContext.displayName = 'Playlists';

export const PlaylistsContextProvider = ({ children }) => {
  const currentUserId = useParams().userId;
  const { user } = useContext(UserContext);
  const currentAuthorId = currentUserId || (user && user.dumpertId) || undefined;
  const [loading, setLoading] = useState(false);
  const userCanEdit = user && user.dumpertId ? user.dumpertId === Number(currentAuthorId) : false;
  const [itemsList, setItemsList] = useState({});
  const playlistItems = itemsList ? Object.values(itemsList).reverse() : [];
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');

  const getPlaylistItems = async () =>
    getUsersPlaylists({
      userId: currentAuthorId,
    })
      .then((res) => {
        setItemsList(res.data);
        setLoading(false);
      })
      .catch((error) => {
        notifyError(error);
        setLoading(false);
      });

  const createNewPlaylist = async (obj) =>
    createPlaylist({ ...obj })
      .then((response) => {
        getPlaylistItems();
        obj.goToEdit
          ? navigate(`/reaguurder/afspeellijst/${currentUserId}/${response.data.id}?edit=true`)
          : notifySuccess('Nieuwe afspeellijst toegevoegd');
      })
      .catch((error) => notifyError(error));

  const deleteCurrentPlaylist = async (obj) => {
    if (window.confirm('Weet je zeker dat je deze playlist wilt verwijderen?')) {
      deletePlaylist({ ...obj })
        .then(() => {
          getPlaylistItems();
          notifySuccess('Afspeellijst verwijderd');
        })
        .catch((error) => notifyError(error));
    }
  };

  const addItemToPlaylists = async (obj) =>
    playlistAddItem({ ...obj })
      .then(() => {
        getPlaylistItems();
        notifySuccess('Item aan afspeellijst toegevoegd');
      })
      .catch((error) => notifyError(error));

  useEffect(() => {
    setLoading(true);
    getPlaylistItems();
  }, [currentAuthorId]);

  return (
    <PlaylistsContext.Provider
      value={{
        currentUserId,
        currentAuthorId,
        playlistItems,
        userCanEdit,
        loading,
        addItemToPlaylists,
        getPlaylistItems,
        createNewPlaylist,
        deleteCurrentPlaylist,
        searchTerm,
        setSearchTerm,
      }}
    >
      {children}
    </PlaylistsContext.Provider>
  );
};
